import PostIt from 'postit-js'
import { mutationNames } from '@/store/storeKey'
import config from '@/config'

const EMULATOR_NAME = 'DEV_SIM'
window.webAppStore = { store: 'initial' }

const createEmulatorPlugin = () => {
  const emulator = PostIt.add(EMULATOR_NAME)
  let source = null
  return store => {
    emulator.on(EMULATOR_NAME, 'ready', (event) => {
      source = event.source
    })
    emulator.on(EMULATOR_NAME, 'load', (event) => {
      let e = JSON.parse(event.data)
      if (e.message === 'loaded') {
        store.commit('SET_DEVSIM_LOADED', true)
      }
    })
    emulator.on(EMULATOR_NAME, 'setDummyMutation', (event) => {
      let finalData = event.dataParsed.appPath
      store.commit('setDummyMutation', finalData)
    })
    emulator.on(EMULATOR_NAME, mutationNames.SHOW_APPPREVIEWER_LINK, (event) => {
      store.dispatch('changeDevice', 'devsimQRcode')
    })
    store.subscribe((mutation, state) => {
      if (source) {
        if (mutation.type === mutationNames.UPDATE_DESIGN_SETTINGS) {
          let DesignSettings = state.subscriptionRelated.subscriptionsDesignSettings
          DesignSettings = {
            ...DesignSettings,
            BackgroundImage: state.system.domainSettings.TextureImagePath + DesignSettings.BackgroundImage
          }
          emulator.emit(EMULATOR_NAME, mutationNames.SET_DESIGN_SETTINGS, source, { DesignSettings }, '*')
        } else if (mutation.type === mutationNames.SET_START_PAGE || mutation.type === mutationNames.UPDATE_START_PAGE_SETTINGS) {
          let MainMenu = state.subscriptionRelated.subscriptionsStartPages
          emulator.emit(EMULATOR_NAME, mutationNames.SET_START_PAGE, source, { MainMenu }, '*')
        } else if (mutation.type === mutationNames.SET_SUBSCRIPTIONS_MODULES || mutation.type === mutationNames.UPDATE_SUBSCRIPTIONS_MODULE) {
          let Items = state.subscriptionRelated.subscriptionsModules
          let SubscriptionsModules = { 'Items': Items.filter(m => m.HideModule === false) }
          emulator.emit(EMULATOR_NAME, mutationNames.SET_SUBSCRIPTIONS_MODULES, source, { SubscriptionsModules }, '*')
        } else if (mutation.type === mutationNames.NAMESPACES.UPDATE_STREAM || mutation.type === mutationNames.NAMESPACES.UPDATE_STREAM_COVER_IMAGE) {
          let stream = state.radioStream.stream
          emulator.emit(EMULATOR_NAME, mutationNames.UPDATE_STREAM, source, { stream }, '*')
        } else if (mutation.type === mutationNames.UPDATE_TEAMPARENT) {
          let parent = state.team.TeamMember.Parent
          emulator.emit(EMULATOR_NAME, mutationNames.UPDATE_TEAMPARENT, source, { parent }, '*')
        } else if (mutation.type === mutationNames.UPDATE_TEAMPRESON || mutation.type === mutationNames.SET_TEAM_MEMBER || mutation.type === mutationNames.UPDATE_TEAM_PERSON_IMAGE) {
          let persons = state.team.TeamMember.Persons
          emulator.emit(EMULATOR_NAME, mutationNames.UPDATE_TEAMPRESON, source, { persons }, '*')
        } else if (mutation.type === mutationNames.NAMESPACES.UPDATE_CONTENT_PARENT || mutation.type === mutationNames.NAMESPACES.SET_CONTENT_PAGE_PARENT) {
          let ContentPageParent = state.textContent.Parent
          emulator.emit(EMULATOR_NAME, mutationNames.SET_CONTENT_PAGE_PARENT, source, { ContentPageParent }, '*')
        } else if (mutation.type === mutationNames.NAMESPACES.UPDATE_CONTENT_PAGE || mutation.type === mutationNames.NAMESPACES.SET_CONTENT_PAGES || mutation.type === mutationNames.NAMESPACES.UPDATE_CONTENT_PAGE_IMAGE) {
          let ContentPages = state.textContent.ContentPages
          emulator.emit(EMULATOR_NAME, mutationNames.SET_CONTENT_PAGES, source, { ContentPages }, '*')
        } else if (mutation.type === mutationNames.NAMESPACES.CREATE_NEW_CONTENT_PAGE) {
          let NewContentPage = mutation.payload
          let moduleId = state.route.params.ModuleId
          let basedOnModuleId = state.route.params.BasedOnModuleId
          if (basedOnModuleId !== null && moduleId !== 1 && moduleId !== 2 && moduleId !== 20) {
            moduleId = basedOnModuleId
          }
          let activeModule = config.moduleMapping.find(mapping => mapping.moduleId === moduleId)
          let detailViewName = ''
          if (activeModule.moduleName === 'news-view') {
            detailViewName = 'news-detail-view'
          } else if (activeModule.moduleName === 'event-view') {
            detailViewName = 'event-detail-view'
          } else if (activeModule.moduleName === 'poi-view') {
            detailViewName = 'poi-detail-view'
          } else {
            detailViewName = 'text-content-detail-view'
          }
          NewContentPage.detailViewName = detailViewName
          emulator.emit(EMULATOR_NAME, mutationNames.CREATE_NEW_CONTENT_PAGE, source, { NewContentPage }, '*')
        } else if (mutation.type === mutationNames.NAMESPACES.UPDATE_NEW_CONTENT_PAGE) {
          let NewContentPagePost = mutation.payload
          emulator.emit(EMULATOR_NAME, mutationNames.UPDATE_NEW_CONTENT_PAGE, source, { NewContentPagePost }, '*')
        } else if (mutation.type === mutationNames.SET_DEVICE) {
          let selectedDevice = state.app.activeDevice
          emulator.emit(EMULATOR_NAME, mutationNames.SET_DEVICE, source, { selectedDevice }, '*')
        } else if (mutation.type === mutationNames.ROUTE_CHANGED) {
          let routeName = mutation.payload.to.name
          let subscriptionModuleId = state.route.params.SubscriptionModuleId
          let basedOnModuleId = state.route.params.BasedOnModuleId
          let moduleId = state.route.params.ModuleId
          let notDefinedLet
          if ((typeof subscriptionModuleId !== typeof notDefinedLet && typeof moduleId !== typeof notDefinedLet) || routeName === 'startpage') {
            if (basedOnModuleId !== null && moduleId !== 1 && moduleId !== 2 && moduleId !== 20) {
              moduleId = basedOnModuleId
            }
            let activeModule = config.moduleMapping.find(mapping => mapping.moduleId === moduleId)
            let activeModulePath = moduleId ? `${activeModule.moduleName}/${subscriptionModuleId}` : `home-view`
            emulator.emit(EMULATOR_NAME, mutationNames.SET_ACTIVE_MODULE, source,
              { ActiveModule: activeModulePath }, '*')
          } else {
            emulator.emit(EMULATOR_NAME, mutationNames.SET_ACTIVE_MODULE, source,
              { ActiveModule: `home-view` }, '*')
            source = null
          }
        } else if (mutation.type === mutationNames.NAMESPACES.SET_CONTENT_EDITING_PAGE) {
          let subscriptionModuleId = state.route.params.SubscriptionModuleId
          let moduleId = state.route.params.ModuleId
          let basedOnModuleId = state.route.params.BasedOnModuleId
          if (basedOnModuleId !== null && moduleId !== 1 && moduleId !== 2 && moduleId !== 20) {
            moduleId = basedOnModuleId
          }
          let activeModule = config.moduleMapping.find(mapping => mapping.moduleId === moduleId)
          let detailViewName = ''
          if (activeModule.moduleName === 'news-view') {
            detailViewName = 'news-detail-view'
          } else if (activeModule.moduleName === 'event-view') {
            detailViewName = 'event-detail-view'
          } else if (activeModule.moduleName === 'poi-view') {
            detailViewName = 'poi-detail-view'
          } else {
            detailViewName = 'text-content-detail-view'
          }
          if (state.textContent.ContentPages.length !== 1) {
            let activeModulePath = mutation.payload ? `${detailViewName}/${subscriptionModuleId}/${mutation.payload}` : `back`
            emulator.emit(EMULATOR_NAME, mutationNames.SET_ACTIVE_MODULE, source,
              { ActiveModule: activeModulePath }, '*')
          }
        } else if (mutation.type === mutationNames.NAMESPACES.CLEAR_CONTENT_EDITING_DATA) {
          emulator.emit(EMULATOR_NAME, mutationNames.CLEAR_CONTENT_EDITING_DATA, source, {}, '*')
        } else if (mutation.type === mutationNames.NAMESPACES.CANCEL_CONTENT_PAGE_EDITING) {
          let contentData = mutation.payload
          emulator.emit(EMULATOR_NAME, mutationNames.CANCEL_CONTENT_PAGE_EDITING, source, { contentData }, '*')
        } else if (mutation.type === 'dummyMutation') {
          emulator.emit(EMULATOR_NAME, 'dummyMutation', source, { AppPath: state.appPath }, '*')
        } else if (mutation.type === 'textContent/UPDATE_UI') {
          emulator.emit(EMULATOR_NAME, 'UPDATE_UI', source, { UI: state.textContent.UI }, '*')
        } else if (mutation.type === 'imageGalleryModule/UPDATE_UI') {
          emulator.emit(EMULATOR_NAME, 'UPDATE_GALLERIE_UI', source, { UI: state.imageGalleryModule.UI }, '*')
        } else if (mutation.type === mutationNames.NAMESPACES.UPDATE_IMAGE_GALLERIE_PARENT || mutation.type === mutationNames.NAMESPACES.SET_IMAGE_GALLERIE_PARENT) {
          let ImageGallerieParent = state.imageGalleryModule.Parent
          emulator.emit(EMULATOR_NAME, mutationNames.SET_IMAGE_GALLERIE_PARENT, source, { ImageGallerieParent }, '*')
        } else if (mutation.type === mutationNames.NAMESPACES.UPDATE_IMAGE_GALLERIE_ALBUM || mutation.type === mutationNames.NAMESPACES.SET_IMAGE_GALLERIE_ALBUMS) {
          let GallerieAlbums = state.imageGalleryModule.GallerieAlbums
          emulator.emit(EMULATOR_NAME, mutationNames.SET_IMAGE_GALLERIE_ALBUMS, source, { GallerieAlbums }, '*')
        } else if (mutation.type === mutationNames.NAMESPACES.CREATE_NEW_IMAGE_GALLERIE_ALBUM) {
          let NewGallerieAlbum = mutation.payload
          let moduleId = state.route.params.ModuleId
          let basedOnModuleId = state.route.params.BasedOnModuleId
          if (basedOnModuleId !== null && moduleId !== 1 && moduleId !== 2 && moduleId !== 20) {
            moduleId = basedOnModuleId
          }
          let detailViewName = 'image-album-view'
          NewGallerieAlbum.detailViewName = detailViewName
          emulator.emit(EMULATOR_NAME, mutationNames.CREATE_NEW_IMAGE_GALLERIE_ALBUM, source, { NewGallerieAlbum }, '*')
        } else if (mutation.type === mutationNames.NAMESPACES.UPDATE_NEW_IMAGE_GALLERIE_ALBUM) {
          let NewGallerieAlbum = mutation.payload
          emulator.emit(EMULATOR_NAME, mutationNames.UPDATE_NEW_IMAGE_GALLERIE_ALBUM, source, { NewGallerieAlbum }, '*')
        } else if (mutation.type === mutationNames.NAMESPACES.SET_IMAGE_GALLERIE_EDITING_ALBUM) {
          let subscriptionModuleId = state.route.params.SubscriptionModuleId
          let moduleId = state.route.params.ModuleId
          let basedOnModuleId = state.route.params.BasedOnModuleId
          if (basedOnModuleId !== null && moduleId !== 1 && moduleId !== 2 && moduleId !== 20) {
            moduleId = basedOnModuleId
          }
          let detailViewName = 'image-album-view'
          if (state.imageGalleryModule.GallerieAlbums.length !== 1) {
            let activeModulePath = mutation.payload ? `${detailViewName}/${subscriptionModuleId}/${mutation.payload}` : `back`
            emulator.emit(EMULATOR_NAME, mutationNames.SET_ACTIVE_MODULE, source,
              { ActiveModule: activeModulePath }, '*')
          }
        } else if (mutation.type === mutationNames.NAMESPACES.CLEAR_IMAGE_GALLERIE_ALBUM_EDITING_DATA) {
          emulator.emit(EMULATOR_NAME, mutationNames.CLEAR_IMAGE_GALLERIE_ALBUM_EDITING_DATA, source, {}, '*')
        } else if (mutation.type === mutationNames.NAMESPACES.CANCEL_IMAGE_GALLERIE_ALBUM_EDITING) {
          let gallerieData = mutation.payload
          emulator.emit(EMULATOR_NAME, mutationNames.CANCEL_IMAGE_GALLERIE_ALBUM_EDITING, source, { gallerieData }, '*')
        } else if (mutation.type === mutationNames.NAMESPACES.SET_MODULE_DATA || mutation.type === mutationNames.NAMESPACES.UPDATE_MODULE_DATA) {
          let formModule = state.formModule.moduleData
          emulator.emit(EMULATOR_NAME, mutationNames.SET_MODULE_DATA, source, { formModule }, '*')
        } else if (mutation.type === mutationNames.NAMESPACES.UPDATE_YOUTUBE) {
          let youtube = state.youtube.youtube
          emulator.emit(EMULATOR_NAME, mutationNames.UPDATE_YOUTUBE, source, { youtube }, '*')
        } else if (mutation.type === mutationNames.NAMESPACES.UPDATE_RSSFEEDDATA) {
          let rssfeed = state.rssfeed.rssFeed
          emulator.emit(EMULATOR_NAME, mutationNames.UPDATE_RSSFEEDDATA, source, { rssfeed }, '*')
        } else if (mutation.type === mutationNames.NAMESPACES.UPDATE_CHAT_MODULE_INFO || mutation.type === mutationNames.NAMESPACES.SET_CHAT_MODULE_INFO) {
          let chatModule = state.chat.ChatModuleInfo
          emulator.emit(EMULATOR_NAME, mutationNames.UPDATE_CHAT_MODULE_INFO, source, { chatModule }, '*')
        } else if (mutation.type === mutationNames.NAMESPACES.UPDATE_CHAT_CHANNEL || mutation.type === mutationNames.NAMESPACES.SET_CHAT_CHANNEL || mutation.type === mutationNames.NAMESPACES.UPDATE_CHAT_CHANNEL_IMAGE) {
          let channel = state.chat.Channels
          emulator.emit(EMULATOR_NAME, mutationNames.UPDATE_CHAT_CHANNEL, source, { channel }, '*')
        } else if (mutation.type === mutationNames.NAMESPACES.SET_CHAT_CHANNEL_EDITING) {
          let subscriptionModuleId = state.route.params.SubscriptionModuleId
          let detailViewName = 'chat-view'
          if (state.chat.Channels.length !== 1) {
            let activeModulePath = mutation.payload ? `${detailViewName}/${subscriptionModuleId}/${mutation.payload}` : `back`
            emulator.emit(EMULATOR_NAME, mutationNames.SET_ACTIVE_MODULE, source,
              { ActiveModule: activeModulePath }, '*')
          }
        } else if (mutation.type === mutationNames.NAMESPACES.CLEAR_CHAT_CHANNEL_EDITING_DATA) {
          emulator.emit(EMULATOR_NAME, mutationNames.CLEAR_CHAT_CHANNEL_EDITING_DATA, source, {}, '*')
        } else if (mutation.type === mutationNames.NAMESPACES.CREATE_NEW_CHAT_CHANNEL) {
          let NewChatChannel = mutation.payload
          let detailViewName = 'chat-view'
          NewChatChannel.detailViewName = detailViewName
          emulator.emit(EMULATOR_NAME, mutationNames.CREATE_NEW_CHAT_CHANNEL, source, { NewChatChannel }, '*')
        } else if (mutation.type === mutationNames.NAMESPACES.UPDATE_NEW_CHAT_CHANNEL) {
          let NewChatChannel = mutation.payload
          emulator.emit(EMULATOR_NAME, mutationNames.UPDATE_NEW_CHAT_CHANNEL, source, { NewChatChannel }, '*')
        } else if (mutation.type === mutationNames.NAMESPACES.CANCEL_CHAT_CHANNEL_EDITING) {
          let channelData = mutation.payload
          emulator.emit(EMULATOR_NAME, mutationNames.CANCEL_CHAT_CHANNEL_EDITING, source, { channelData }, '*')
        } else if (mutation.type === mutationNames.NAMESPACES.UPDATE_TWITTERDATA) {
          let twitter = state.twitter.Twitter
          emulator.emit(EMULATOR_NAME, mutationNames.UPDATE_TWITTERDATA, source, { twitter }, '*')
        } else if (mutation.type === mutationNames.NAMESPACES.UPDATE_WEBSITE) {
          let website = state.website.Website
          emulator.emit(EMULATOR_NAME, mutationNames.UPDATE_WEBSITE, source, { website }, '*')
        } else if (mutation.type === mutationNames.NAMESPACES.UPDATE_INSTAGRAM) {
          let instagram = state.instagram.Instagram
          emulator.emit(EMULATOR_NAME, mutationNames.UPDATE_INSTAGRAM, source, { instagram }, '*')
        } else if (mutation.type === mutationNames.NAMESPACES.UPDATE_FACEBOOK) {
          let facebook = state.facebook.Facebook
          emulator.emit(EMULATOR_NAME, mutationNames.UPDATE_FACEBOOK, source, { facebook }, '*')
        } else if (mutation.type === mutationNames.NAMESPACES.SET_CUSTOMCODE || mutation.type === mutationNames.NAMESPACES.UPDATE_CUSTOMCODE) {
          let customCode = state.customCode.customCode
          emulator.emit(EMULATOR_NAME, mutationNames.UPDATE_CUSTOMCODE, source, { customCode }, '*')
        } else if (mutation.type === mutationNames.UPDATE_PDFMODULEINFO) {
          let pdfModuleInfo = state.pdfModule.pdfModuleInfo
          emulator.emit(EMULATOR_NAME, mutationNames.UPDATE_PDFMODULEINFO, source, { pdfModuleInfo }, '*')
        } else if (mutation.type === mutationNames.NAMESPACES.UPDATE_PDFDOCLIST) {
          let pdfDocList = state.pdfModule.pdfDocList
          emulator.emit(EMULATOR_NAME, mutationNames.UPDATE_PDFDOCLIST, source, { pdfDocList }, '*')
        }
        // console.log(mutation.type)
      }
    })
  }
}

export default createEmulatorPlugin



// WEBPACK FOOTER //
// ./src/plugins/Emulator.js